"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaResultList = _interopRequireDefault(require("./components/KansaResultList"));
var _KansaResultSearchCondition = _interopRequireDefault(require("./components/KansaResultSearchCondition"));
var _kansaResultActions = require("./kansaResultActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledCardContent = (0, _styles.styled)(_material.CardContent)({
  width: '100%'
});
class KansaResultMain extends _react.default.Component {
  constructor(props) {
    super(props);
    if (props.shareCondition.init) {
      props.applyCondition(props.shareCondition);
    }
  }
  componentDidMount() {
    const {
      scrollY,
      noSticky
    } = this.props.scrollTop;
    if (noSticky) {
      _windowUtil.default.windowScroll(scrollY);
    } else {
      window.scrollTo(0, 0);
    }
  }
  render() {
    const {
      intl,
      searchResult,
      paging,
      setKansaInfo,
      resetPaging,
      changePage,
      changeViewNum,
      scrollTop,
      onScroll,
      soshikiShowAll,
      changeShowAll
    } = this.props;

    // 監査結果_参照ボタン押下ハンドラ
    const onResultReferClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.RESULT_REFER, false);
    };

    // 監査結果（詳細）_参照ボタン押下ハンドラ
    const onResultReferOldClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.RESULT_REFER_OLD, false);
    };

    // 監査結果_登録ボタン押下ハンドラ
    const onResultRegistClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.RESULT_REGISTER, false);
    };

    // 監査結果_更新ボタン押下ハンドラ
    const onResultUpdateClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.RESULT_UPDATE, false);
    };

    // 指摘事項_参照ボタン押下ハンドラ
    const onShitekiReferClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.SHITEKI_DETAIL, false);
    };

    // 指摘事項（詳細）_参照ボタン押下ハンドラ
    const onShitekiReferOldClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.SHITEKI_OLD_DETAIL, false);
    };

    // 指摘事項_登録ボタン押下ハンドラ
    const onShitekiRegistClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.SHITEKI_ENTRY, false);
    };

    // 指摘事項_更新ボタン押下ハンドラ
    const onShitekiUpdateClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.SHITEKI_ENTRY, false);
    };

    // 責任者評価_参照ボタン押下ハンドラ
    const onChiefHyokaReferClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.HIKANSA_DETAIL, false);
    };

    // 責任者評価_登録ボタン押下ハンドラ
    const onChiefHyokaRegistClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.HIKANSA_ENTRY, false);
    };

    // 責任者評価_更新ボタン押下ハンドラ
    const onChiefHyokaUpdateClick = kansaInfo => {
      setKansaInfo(kansaInfo, _kansaResultActions.CONTENTS.HIKANSA_ENTRY, false);
    };
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_TITLE
      }),
      help: /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: _labelConsts.LABEL.KANSA_KANSA_RESULT_HELP
      })
    }, /*#__PURE__*/_react.default.createElement(StyledCardContent, null, /*#__PURE__*/_react.default.createElement(_KansaResultSearchCondition.default, null), /*#__PURE__*/_react.default.createElement(_KansaResultList.default, {
      onResultReferClick,
      onResultReferOldClick,
      onResultRegistClick,
      onResultUpdateClick,
      onShitekiReferClick,
      onShitekiReferOldClick,
      onShitekiRegistClick,
      onShitekiUpdateClick,
      onChiefHyokaReferClick,
      onChiefHyokaRegistClick,
      onChiefHyokaUpdateClick,
      searchResult,
      paging,
      resetPaging,
      changePage,
      changeViewNum,
      scrollTop,
      onScroll,
      soshikiShowAll,
      changeShowAll
    })));
  }
}
const mapStateToProps = state => {
  return {
    searchResult: state.kansaResult.searchResult,
    paging: state.kansaResult.paging,
    scrollTop: state.kansaResult.scrollTop,
    soshikiShowAll: state.kansaResult.soshikiShowAll,
    shareCondition: state.kansaShareCondition
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setKansaInfo: (kansaInfo, dispContent, isProgress) => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_KANSA_INFO](kansaInfo, dispContent, isProgress)),
    resetPaging: () => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.RESET_PAGING]()),
    changePage: currentPage => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_PAGE](currentPage)),
    changeViewNum: viewNum => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_VIEW_NUM](viewNum)),
    changeShowAll: soshikiShowAll => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_SHOW_ALL](soshikiShowAll)),
    onScroll: scrollTop => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_SCROLL_TOP](scrollTop)),
    applyCondition: condition => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.APPLY_SHARE_CONDITION](condition))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(KansaResultMain));